import React, { Component } from "react";
import { NavLink } from "react-router-dom";

class ConfirmButton extends Component {
  render() {
    const { onClick, label, path, classes, disabled } = this.props;
    const isDisabled = disabled ? "p-btn-disabled" : null;

    return path ? (
      <NavLink to={`${path}`}>
        <span className={`p-btn p-btn-green ${isDisabled}`}>{label}</span>
      </NavLink>
    ) : (
      <span className={`p-btn p-btn-green ${isDisabled} ${classes}`} onClick={disabled ? null : onClick}>
        {label}
      </span>
    );
  }
}

export default ConfirmButton;



// WEBPACK FOOTER //
// src/components/buttons/ConfirmButton.js